import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import {
  Card,
  CardContent,
  Typography,
  makeStyles
} from "@material-ui/core";

import BillingPeriod from "../../../cargotic-common/billingPeriod";

const useStyles = makeStyles(({ spacing }) => ({
  table: {
    borderSpacing: 0,

    "& td": {
      padding: spacing(0.75, 0),
      verticalAlign: "top"
    },
    "& td:first-child": {
      paddingRight: spacing(4),
      whiteSpace: "nowrap"
    }
  },
  value: {
    overflowWrap: "anywhere"
  },
  note: {
    marginTop: spacing(3)
  },
  noteText: {
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere"
  }
}));

const billingPeriodLabelKeys = {
  [BillingPeriod.Immediately]: "webapp:common.title.immediately",
  [BillingPeriod.HalfMonth]: "webapp:common.title.half-month",
  [BillingPeriod.Month]: "webapp:common.title.month",
  [BillingPeriod.Week]: "webapp:common.title.week"
};

const ContactBillingOverview = ({
  className,
  contact: {
    id,
    name,
    ico,
    dic,
    billingPeriod,
    billingContact,
    paymentDueDays,
    isBilledOnline,
    billingAddress,
    note
  },
  onBreadcrumbsChange
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    onBreadcrumbsChange([
      { label: t("webapp:common.title.contacts"), href: "/contacts" },
      { label: name, href: `/contacts/${id}` },
      { label: t("webapp:common.title.billing") }
    ]);
  }, []);

  const rows = [
    [t("webapp:common.title.ico"), ico],
    [t("webapp:common.title.dic"), dic],
    [
      t("webapp:common.title.billing-period"),
      billingPeriodLabelKeys[billingPeriod]
        ? t(billingPeriodLabelKeys[billingPeriod])
        : undefined
    ],
    [t("webapp:contact.title.billingContact"), billingContact || undefined],
    [t("webapp:common.title.payment-due-days"), paymentDueDays],
    [
      t("webapp:contact.title.isBilledOnline"),
      isBilledOnline ? t("yes") : t("no")
    ],
    [t("webapp:common.title.billing-address"), billingAddress || undefined]
  ];

  return (
    <div className={className}>
      <Card>
        <CardContent>
          <table className={classes.table}>
            <tbody>
              {rows.map(([label, value]) => (
                <tr key={label}>
                  <td>
                    <Typography color="textSecondary">
                      {label}
                    </Typography>
                  </td>
                  <td>
                    <Typography className={classes.value}>
                      {value ?? "-"}
                    </Typography>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={classes.note}>
            <Typography color="textSecondary">
              {t("webapp:common.title.note")}:
            </Typography>
            <Typography className={classes.noteText}>
              {note || "-"}
            </Typography>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ContactBillingOverview;
